import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import "./style.css";
import BackArrow from "../../../../components/backArrow";

const ProjectDetails = () => {
  return (
    <Row>
      <div className="screenHeight d-flex justify-content-center align-items-center p-3">
        <Col lg="9" className="project-card shadow b-radius">
          <BackArrow />

          <img
            src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c"
            alt="project"
            className="project-image mt-3"
          />

          <h2 className="project-title">
            Sustainable Urban Development Project
          </h2>

          <p className="project-description">
            This project focuses on developing eco-friendly urban spaces with a
            mix of residential, commercial, and recreational areas. The
            development incorporates green technologies, sustainable materials,
            and smart city solutions to minimize environmental impact and
            enhance quality of life for residents. The project aims to create a
            vibrant, self-sufficient community that promotes sustainability and
            innovation.
          </p>

          <div className="project-info">
            <p>
              <strong>Location:</strong> xyz
            </p>
            <p>
              <strong>Expected ROI:</strong> 12-15%
            </p>
            <p>
              <strong>Minimum Investment:</strong> RS 10000
            </p>
            <p>
              <strong>Timeline:</strong> 3–5 Years
            </p>
          </div>

          <div className="attachments">
            <strong>Attachments:</strong>
            <div className="attachment-link">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2991/2991102.png"
                alt="file"
                className="attachment-icon"
              />
              <a href="/files/sample.pdf" download>
                View Attached File
              </a>
            </div>
          </div>

          <div className="contact-info">
            <strong>Contact Info</strong>
            <p>
              <strong>Email:</strong> username@gmail.com
            </p>
            <p>
              <strong>Contact:</strong> 0123456789
            </p>
          </div>

          <div className="message-btn-wrapper">
            <Button className="message-btn w-50">Message</Button>
          </div>
        </Col>
      </div>
    </Row>
  );
};

export default ProjectDetails;
